<template>
<span id="add-charge-code">
  <el-button
    v-if="!isEditMode"
    id="add-charge-code-button"
    class="button-action-default"
    size="mini"
    type="success"
    plain
    @click="dialogVisible = true"
  >
    {{ $t('tariff.chargeCodes.newChargeCodeButton') }}
  </el-button>
  <i v-if="isEditMode" class="el-icon-edit header-info-dialog-value icon-action" id="btn-unit-detail" @click="toggleVisible" size="mini" icon="el-icon-plus"></i>


  <el-dialog
      id="add-charge-code-dialog"
      :title="isEditMode ? '' :$t('tariff.chargeCodes.addChargeCode')"
      :visible.sync="dialogVisible"
      width="60%"
      class="dialog-with-cols"
      :close-on-click-modal="false"
      append-to-body
      :before-close="closeDialog"
  >
    <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row :gutter="20">
        <el-col :span="8">
          <span class="title-list">{{ $t('tariff.chargeCodes.informationTitle') }}</span>
        </el-col>
      </el-row>

      <!-- Information Section -->
          <el-row>
            <!-- Charge Code Name -->
             <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.name')" prop="name" ref="name">
                  <el-input
                    v-model="form.name"
                    clearable
                    size="mini"
                    class="input-search"
                  />
              </el-form-item>
            </el-col>

            <!-- Code -->
            <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.code')" prop="code" ref="code">
                  <el-input
                    v-model="form.code"
                    clearable
                    size="mini"
                    class="input-search"
                    maxlength="4"
                  />
              </el-form-item>
            </el-col>

            <!--Charge Code Type-->
            <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.type')" prop="chargeType" ref="chargeType">
                  <charge-code-type-select v-model="form.chargeType" :default-all="false" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!--Revenue Charge-->
            <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.revenueCharge')" prop="chargeCodeRevenueCharge" ref="chargeCodeRevenueCharge">
                  <el-checkbox
                    v-model="form.revenueCharge"
                    class="inline-input"
                    size="mini"
                  ></el-checkbox>
              </el-form-item>
            </el-col>

            <!--Priority-->
            <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.priority')" prop="chargeCodePriority" ref="chargeCodePriority">
                  <el-input
                    v-model="form.priority"
                    clearable
                    size="mini"
                    class="input-search"
                    @input="form.priority = form.priority.replace(/\D/g, '')"

                  />
              </el-form-item>
            </el-col>

            <!--Status-->
            <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.status')" prop="chargeCodeActive" ref="chargeCodeActive">
                  <status-select v-model="form.status"/>
              </el-form-item>
            </el-col>

          </el-row>
          <!--Rate
          <el-row>
            <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.rate')" prop="chargeCodeRate" ref="chargeCodeRate">
                  <el-input
                    v-model="form.rate"
                    clearable
                    size="mini"
                    class="input-search"
                    @input="form.rate = form.rate.replace(/\D/g, '')"
                  />
              </el-form-item>
            </el-col>
          </el-row>
            -->
          <!--Sage Intact Section-->
          <el-row :gutter="20">
            <el-col :span="8">
              <span class="title-list">{{ $t('tariff.chargeCodes.sageIntacctTitle') }}</span>
            </el-col>
          </el-row>


          <el-row>
          <!--Sage Account-->
          <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.sageAccount')" prop="sageAccount" ref="sageAccount">
                  <el-input
                    v-model="form.sageAccount"
                    clearable
                    size="mini"
                    class="input-search"
                    @input="form.sageAccount = form.sageAccount.replace(/[^0-9.]/g, '')"
                  />
              </el-form-item>
            </el-col>

          <!--Department-->
          <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.department')" prop="department" ref="department">
                  <el-input
                    v-model="form.department"
                    clearable
                    size="mini"
                    class="input-search"
                    @input="form.department = form.department.replace(/\D/g, '')"
                  />
              </el-form-item>
            </el-col>

          <!--Location-->
          <el-col :span="8" class="form-vertical-item">
              <el-form-item :label="$t('tariff.chargeCodes.location')" prop="location" ref="location">
                  <el-input
                    v-model="form.location"
                    clearable
                    size="mini"
                    class="input-search"
                    @input="form.location = form.location.replace(/\D/g, '')"
                  />
              </el-form-item>
            </el-col>
          </el-row>
    </el-form>
    <div
          id="add-charge-code-dialog-footer"
          slot="footer"
          class="dialog-footer form-vertical-item flex-reverse-direction"
        >
          <el-button
            type="primary"
            id="save-storage-location-button"
            @click="submitForm()"
            size="mini"
          >{{ $t('common.save') }}</el-button>
          <el-button
            id="refresh-storage-location-button"
            @click="resetForm()"
            size="mini"
          >{{ $t('common.clear') }}</el-button>
        </div>
  </el-dialog>

</span>
</template>

<script>
import { Message } from 'element-ui';
import { CHARGE_CODE_LIST_SEARCH, CHARGE_CODE_SAVE } from '@/store/actions';
import constants from '@/utils/constants';
import ChargeCodeTypeSelect from '../chargeCodeTypes/chargeCodeTypeSelect';
import StatusSelect from '../chargeCodeStatus/ChargeCodeStatusSelect';

export default {
  name: 'AddChargeCode',
  components: {
    ChargeCodeTypeSelect,
    StatusSelect
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        id: null,
        name: null,
        code: null,
        chargeType: null,
        revenueCharge: null,
        priority: null,
        status: true,
        department: null,
        location: null,
        sageAccount: null,
        // rate: null
      },
      formRules: {
        name: [
          {
            required: true,
            message: this.$t('tariff.chargeCodes.error.nameRequired'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: this.$t('tariff.chargeCodes.error.codeReqired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 4,
            message: this.$t('tariff.chargeCodes.error.codeLength'),
            trigger: 'blur'
          }
        ],
        chargeType: [
          {
            required: true,
            message: this.$t('tariff.chargeCodes.error.typeRequired'),
            trigger: 'blur'
          }
        ],
        revenueCharge: [
          {
            required: false,
            message: this.$t('tariff.chargeCodes.error.revenueChargeRequired'),
            trigger: 'blur'
          }
        ],
        priority: [
          {
            required: false,
            message: this.$t('tariff.chargeCodes.error.priorityRequired'),
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: false,
            message: this.$t('tariff.chargeCodes.error.statusRequired'),
            trigger: 'blur'
          }
        ],
        department: [
          {
            required: true,
            message: this.$t('tariff.chargeCodes.error.departmentRequired'),
            trigger: 'blur'
          }
        ],
        location: [
          {
            required: true,
            message: this.$t('tariff.chargeCodes.error.locationRequired'),
            trigger: 'blur'
          }
        ],
        sageAccount: [
          {
            required: true,
            message: this.$t('tariff.chargeCodes.error.sageAccountrequired'),
            trigger: 'blur'
          }
        ],
        /* rate: [
          {
            required: true,
            message: this.$t('tariff.chargeCodes.error.rateRequired'),
            trigger: 'blur'
          }
        ], */
      },
    };
  },
  props: {
    chargeCode: {
      type: Object,
      required: false,
      default: () => ({})
    },
  },
  computed: {
    isEditMode() {
      return this.chargeCode && Object.keys(this.chargeCode).length > 0;
    },
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm() {
      if (!this.isEditMode) {
        this.form = {
          id: null,
          chargeCodeName: null,
          code: null,
          chargeType: null,
          revenueCharge: null,
          priority: null,
          department: null,
          location: null,
          sageAccount: null,
          status: true,
          // rate: null
        };
      } else {
        this.fillForm();
      }
    },
    toggleVisible() {
      this.dialogVisible = !this.dialogVisible;
      if (this.dialogVisible) {
        this.fillForm();
      }
    },
    fillForm() {
      if (this.isEditMode) {
        this.form.id = this.chargeCode.id;
        this.form.name = this.chargeCode.name;
        this.form.code = this.chargeCode.code;
        this.form.priority = this.chargeCode.priority;
        this.form.status = this.chargeCode.status;
        this.form.department = this.chargeCode.department;
        this.form.location = this.chargeCode.location;
        this.form.sageAccount = this.chargeCode.sageAccount;
        this.form.revenueCharge = this.chargeCode.revenueCharge;
        this.form.chargeType = this.chargeCode.chargeType;
        // this.form.rate = this.chargeCode.rate;
      }
    },
    async submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.form.location = Number(this.form.location);
            this.form.department = Number(this.form.department);
            this.form.sageAccount = Number(this.form.sageAccount);
            this.form.revenueCharge = this.form.revenueCharge || false;
            this.form.chargeType = this.form.chargeType;
            this.form.rate = Number(this.form.rate);

            this.$store
              .dispatch(CHARGE_CODE_SAVE, this.form)
              .then((response) => {
                loading.close();
                this.$message.success(response.message);
                this.closeDialog();
                this.$store.dispatch(CHARGE_CODE_LIST_SEARCH, {});
                resolve(response);
              })
              .catch((error) => {
                loading.close();
                resolve(error);
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
  },

};
</script>
